/* eslint-disable spaced-comment */
export function detectIE() {
  const isIE = /*@cc_on!@*/false || !!document.documentMode;
  const isEdge = !isIE && !!window.StyleMedia;

  if (isIE) {
    document.body.classList.add('ie-11');
  }

  if (isEdge) {
    document.body.classList.add('ie-edge');
  }
}

export function enableJS() {
  document.documentElement.className = document.documentElement.className.replace(/\bno-js\b/, '');
}

export function isAppleDevice() {
  const iDevices = [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod',
  ];

  if (navigator.platform) {
    while (iDevices.length) {
      if (navigator.platform === iDevices.pop()) {
        return true;
      }
    }
  }

  return false;
}

export function isAndroidDevice() {
  return /(android)/i.test(navigator.userAgent);
}
